const SplitColumns = ({ children }) => {
    return (
        <div className={"grid grid-cols-2 [&_*:nth-of-type(2n+1)]:text-textGrey [&_*:nth-of-type(2n)]:text-right"}>
            {children}
        </div>
    )
}

export default SplitColumns